/**
 * workflow-core
 *
 * Copyright (c) Ballerine
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
import '../check-is-iso-date/check-is-iso-date.js';
import '../check-is-url/check-is-url.js';
import '../collection-flow/validators/index.js';
import '../collection-flow/schemas/config-schema.js';
import '../../consts/index.js';
import 'crypto-js';
import { valueOrFallback } from '../value-or-fallback/value-or-fallback.js';
import 'zod';
import '../../countries/index.js';
import '../countries-data-shared/countries-data-shared.js';

/**
 * @description Returns 'N/A' if value is falsy.
 */
var valueOrNA = valueOrFallback('N/A', {
  checkFalsy: true
});

export { valueOrNA };
//# sourceMappingURL=value-or-na.js.map
